/**
 * Helper component for rendering basic text inputs
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

const TextInput = ({
  change
  , disabled
  , helpText
  , label
  , name
  , placeholder
  , required
  , className
  , value = ''
  , inputClassName = ''
  , ...inputProps
}) => {
  return (
    <div className={className ? className : "relative z-0 w-full mb-4 text-left"}>
      {label ? (
        <label
          htmlFor={name}
          className="px-2 pt-1 text-xs absolute top-0 text-neutral-sec bg-transparent z-10"
        >
          {label} <sup className="text-red-500">{required ? '*' : null}</sup>
        </label>
        )
        :
        null
      }
      <input
        disabled={disabled}
        name={name}
        onChange={change}
        placeholder={placeholder}
        required={required}
        type="text"
        value={value}
        className={`px-2 text-inherit bg-neutral-pri ${label ? 'pt-5 pb-1' : 'pt-2 pb-2'} block w-full mt-0 ${inputClassName}`}
        {...inputProps}
      />
      {helpText && <small className="text-xs text-neutral-sec"><em>{helpText}</em></small>}
    </div>
  )
}

TextInput.propTypes = {
  change: PropTypes.func.isRequired
  , disabled: PropTypes.bool
  , helpText: PropTypes.any
  , label: PropTypes.string
  , name: PropTypes.string.isRequired
  , placeholder: PropTypes.string
  , required: PropTypes.bool
  , className: PropTypes.string
  , value: PropTypes.string
  , inputProps: PropTypes.object
}

TextInput.defaultProps = {
  disabled: false
  , helpText: null
  , label: ''
  , placeholder: ''
  , required: false
}

export default TextInput;
